import { MfNode } from "../node";
import { ExprBoolCtx } from "../node/createExprBool";

export const recalcNode = (node: MfNode, ctx: ExprBoolCtx) => {
  node.recalc(ctx);
  node.items?.forEach((it) => recalcNode(it, ctx));
};
